import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';
import { SmsLogService } from '../../shared/services/sms-log/sms-log.service';
import { TimeFormatterIso } from '../../shared/utilities/date-formatter.utils';
import { InitialsUtils } from '../../shared/utilities/name.initials.utils';
import { StringUtils } from '../../shared/utilities/string.utlis';
import { AlertStatusEnum } from '../../shared/enums/alert-status.enum';
import { CommonService } from '../../shared/services/common/common.service';
import { SharedModule } from '../../shared/modules/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AlertService } from '../../shared/services/alert/alert.service';
import { UtilitiesService } from '../../shared/services/utilities/utilities.service';

@Component({
  selector: 'app-sms-modal',
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    ButtonModule,
    TableModule,
    SharedModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: './sms-modal.component.html',
  styleUrl: './sms-modal.component.scss',
})
export class SmsModalComponent {
  @Input() drawerVisible = false;
  @Input() smsData: any;
  @Output() drawerVisibleChange = new EventEmitter<boolean>();

  TimeFormatterIso = TimeFormatterIso;
  InitialsUtils = InitialsUtils;
  StringUtils = StringUtils;
  AlertStatusEnum = AlertStatusEnum;
  isDeleteModalOpen: boolean = false;
  alertId: string = '';
  selectedRecipientId: string = '';
  totalRecords = 0;
  loading = false;

  propertyId!: string;
  page = 1;
  limit = 10;

  smsDetails = {
    message: '',
    time: '',
    recipients: [] as any[],
  };

  constructor(
    private readonly smsLogService: SmsLogService,
    private readonly localStorageService: LocalStorageService,
    public readonly commonService: CommonService,
    private readonly alertService: AlertService,
    private readonly utilitiesService: UtilitiesService,
  ) {
    this.propertyId =
      this.localStorageService.getSessionPropertyStaff()?.property?.id;
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.smsData);
    if (
      changes['smsData'] &&
      this.drawerVisible &&
      this.smsData?.id &&
      this.propertyId
    ) {
      this.SmsAlertLogs(this.propertyId);
    }
  }

  SmsAlertLogs(propertyId: string): void {
    this.loading = true;

    this.smsLogService
      .smsAlertLogs({
        propertyId: this.propertyId,
        uniqueId: this.smsData.uniqueId,
        page: this.page,
        limit: this.limit,
      })
      .subscribe({
        next: (res: any) => {
          const logs = res?.result?.data ?? [];
          this.totalRecords = res?.result?.total ?? 0;

          const sent = this.smsData?.status?.sent ?? 0;
          const failed = this.smsData?.status?.failed ?? 0;

          this.smsDetails = {
            message: this.smsData.message ?? 'N/A',
            time: this.smsData.date,
            recipients:
              sent === 0 && failed === 0
                ? []
                : logs.map((item: any) => ({
                    id: item.id,
                    name: item.recipientName?.trim() || 'N/A',
                    method: item.alertType,
                    status: item.status,
                  })),
          };
        },
        error: (err) => {
          console.error('Failed to load SMS alert logs', err);
          this.smsDetails.recipients = [];
          this.totalRecords = 0;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  onPageChange(event: any): void {
    this.limit = event.rows;
    this.page = Math.floor(event.first / event.rows) + 1;
    this.SmsAlertLogs(this.propertyId);
  }

  closeDrawer() {
    this.drawerVisible = false;
    this.drawerVisibleChange.emit(false);
  }

  resend(recipient: any) {}
  openDeleteModal(id: string) {
    this.selectedRecipientId = id;
    this.isDeleteModalOpen = true;
  }

  closeModal() {
    this.isDeleteModalOpen = false;
  }

  deleteSingleAlert() {
    const alertId = this.selectedRecipientId;
    if (!alertId) {
      console.error('Cannot delete: id is missing!');
      return;
    }
    this.alertService.deleteBulkAlert(alertId).subscribe({
      next: (res) => {
        this.smsDetails.recipients = this.smsDetails.recipients.filter(
          (r) => r.id !== this.selectedRecipientId,
        );

        this.closeModal();
      },
      error: (err) => {
        console.error('Failed to delete alert ', err);
      },
    });
  }

  resendAlert(id: string): void {
    if (!id) {
      console.error('alertId is missing.');
      return;
    }

    const payload = {
      alertLogId: id,
    };

    this.alertService.resendAlert(payload).subscribe({
      next: () => {
        this.showToast('Successful', 'Resend successfully');
      },
      error: (err) => {
        console.error('Send alert failed:', err);
      },
    });
  }

  private showToast(title: string, message: string) {
    this.utilitiesService.showSwalWithToast(
      title,
      message,
      'success',
      true,
      5000,
    );
  }
}
